export const getFullArtifactVersion = (
  name: string,
  version: string,
  packageType: string
) => {
  switch (packageType) {
    case 'helm':
      return `${name}/${version}`;
    case 'go':
      return `${name}@${version}`;
    case 'nuget':
      return `${name} ${version}`;
    case 'pypi':
      return `${name}==${version}`;
    case 'maven':
    case 'docker':
    case 'gradle':
    case 'generic':
      return `${name}:${version}`;
    case 'npm':
      return `${name}@${version}`;
    default:
      return `${name} v${version}`;
  }
};
